import React from 'react'
import { useViewport } from '../../../utils'

const CardAvatar = ({image, bookmark}) => {
  const { isMobile } = useViewport()
  const size = isMobile ? '78px' : bookmark ? '110px' : '150px'

  return (
    <div
      style={{minWidth: size, height: size}}
      className="mr-4 lg:mr-8 flex justify-center items-center"
    >
      <div
        className="w-full h-full bg-center bg-auto bg-no-repeat rounded-full shadow"
        style={{
          backgroundColor: '#f9f9f9',
          backgroundImage: `url('${image}')`,
          backgroundBlendMode: 'multiply',
          backgroundSize: '60%'
        }}
      />
      {/* <img src={`${image}`} alt="logo" style={{backgroundBlendMode: 'multiply'}}/> */}
    </div>
  )
}

export default CardAvatar
